import styled from 'styled-components';
import { TypeaheadTimePicker } from 'ui/datePicker';
import { DatePickerWrapper } from 'ui/datePicker/DatePicker.styles';
import { Positioner, StyledWrapper } from 'ui/inputs/InputStyles';
import { SelectWrapper } from 'ui/selects';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p66: pxToRem(66),
};

export const DateTimePickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing.half};

  > div {
    flex: 1;
  }

  ${DatePickerWrapper} {
    width: 100%;
  }

  ${SelectWrapper} {
    &:hover {
      background-color: ${colors.white};
    }
    &:focus-within {
      background-color: ${colors.white};
    }
  }

  ${StyledWrapper} {
    flex: 0;
    &:focus-within {
      box-shadow: none;
    }
  }

  ${Positioner} {
    margin: 0;
  }
`;

export const StyledTypeaheadTimePickerField = styled(TypeaheadTimePicker)`
  input {
    width: ${customSpacing.p66} !important;
  }
`;
